export default "__VITE_ASSET__308940eb__"